import { useDispatch } from 'react-redux';
import { PATH_HONHAI } from '../router/paths';
import Label from '../components/label';
import { SvgChatDotFill, SvgLogoutFill, SvgLinkFill } from '../components/SvgIcons';



const getIcon = (name) => '';

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
};

// ======================================================================================== //

/* 相信下載 */
const icivetDownloadURL = 'http://icivet.foxconn.com/Download';

/* 問題回報 */
const feedbackReportURL = 'https://civetinterface.foxconn.com/Open/oauth/SaaS000298/FeedbackAdd/List';

/* 問題記錄 */
const feedbackListURL = 'https://civetinterface.foxconn.com/Open/oauth/SaaS000298/FeedbackMyList/List';

const mock_account =  ({ t, i18n, dispatch }) => {
  return {
    displayName: 'Ping',
    email: 'henry.hp.jiang@foxconn.com',
    photoURL: '/assets/images/avatars/avatar_default.jpg',
    icivetDownloadURL,
    /* 問題回報 */
    feedbackReportURL,
    /* 問題記錄 */
    feedbackListURL,
    connect: {
      title: '聯繫窗口',
      name: '徐庭芳',
      extension: '5010+11007',
      email: 'addie.tf.hsu@foxconn.com',
      address: '中央人資辦公室(虎躍廠五樓)',
      records: [
        '聯繫人：徐庭芳',
        '分機：5010+11007',
        '信箱：addie.tf.hsu@foxconn.com',
        '辦公地點：中央人資辦公室(虎躍廠五樓)',
      ]
    },
    contact: {
      title: '聯繫窗口',
      name: '丁彗玲',
      extension: '5010+11014',
      email: 'vera.hl.ding@foxconn.com',
      address: '中央人資辦公室(虎躍廠五樓)',
      records: [
        '聯繫人：丁彗玲',
        '分機：5010+11014',
        '信箱：vera.hl.ding@foxconn.com',
        '中央人資辦公室(虎躍廠五樓)',
      ]
    },
    title: "中央總務服務平臺",
    navigations: [
      {
        items: [
          { lng: '首頁', title: t('ese.home'),      path: PATH_HONHAI.general.app, icon: ICONS.dashboard,  },
          {
            lng: '關於總務',
            breadcrumb: 'about',
            title: `關於總務`,
            path: PATH_HONHAI.about.root,
            children: [
              {
                breadcrumb: 'business-introduce',
                title: '中央總務介紹',
                path: PATH_HONHAI.about.introduce
              },
              {
                breadcrumb: 'factory-contact',
                title: '各廠服務窗口',
                path: PATH_HONHAI.about.contact
              },
              {
                breadcrumb: 'stationary-position',
                title: '駐點位置',
                path: PATH_HONHAI.about.stationary
              },
            ],
          },
        ],
      },
    ],
  }
};

export default mock_account;
